import { render, staticRenderFns } from "./DesignerMenu.vue?vue&type=template&id=d934e6c4&scoped=true"
import script from "./DesignerMenu.vue?vue&type=script&lang=js"
export * from "./DesignerMenu.vue?vue&type=script&lang=js"
import style0 from "./DesignerMenu.vue?vue&type=style&index=0&id=d934e6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d934e6c4",
  null
  
)

export default component.exports